import { render } from "./AddEditGimBrand.vue?vue&type=template&id=4ae34438"
import script from "./AddEditGimBrand.vue?vue&type=script&lang=js"
export * from "./AddEditGimBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__